<template>
    <section class="content">
        <div class="box box-info">
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-2" id="billNo" >
                  <label for="billNo" >Transfor No :</label>
                  <span class="purchaseOutput "><b>{{salesHeaderObj.transforNo}}</b></span>
              </div>
              <!-- <div class="p-field p-col-12 p-md-2">
                    <label for="referenceNumber" >Reference No. :</label>
                    <span class="purchaseOutput ">
                      <b>{{salesHeaderObj.referenceNumber}} </b>
                    </span>
               </div> -->
               <div class="p-field p-col-12 p-md-2">
                  <label for="salesDate" >Date :</label>
                  <span class="purchaseOutput"><b>{{salesHeaderObj.transforDate}}</b></span>
               </div>
               <div class="p-field p-col-12 p-md-2">
                    <label for="WarehouseName" >From Store :</label>
                    <span class="purchaseOutput ">
                      <b>{{salesHeaderObj.warehouseFromName}} </b>
                    </span>
               </div>

               <div class="p-field p-col-12 p-md-2">
                    <label for="WarehouseName" >To Store :</label>
                    <span class="purchaseOutput ">
                      <b>{{salesHeaderObj.warehouseToName}} </b>
                    </span>
               </div>  
                <div class="p-field p-col-12 p-md-6"></div>

             </div>
               <table class="table table-bordered ">
                <thead >
                  <tr>
                    <th>SN</th>
                    <th>Item Name</th>
                    <th>Quantity</th>
                    <th>Rate</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody  v-for="(pd,index) in inventoryInOutDetailList " :key="index">
                  <tr>
                    <td>{{index+1}}</td>
                    <td>{{pd.name}}</td>
                    <td>{{pd.quantity}}</td>
                    <td>{{pd.rate}}</td>
                    <td>{{pd.quantity * pd.rate}} </td>
                  </tr>
                </tbody>
              </table>

           <div class="col-md-6" v-if="this.extraExpensesList.length>0">
             <h5>Extra Expenses:</h5>
            <table class="table table-bordered " style="margin-top: 2%;">
            <thead>
              <tr>
                <th scope="col">SN</th>
                <th scope="col">Name</th>
                <th scope="col">Amount</th>
                <th scope="col">Vatable</th>
                <th scope="col">Debit Account</th>
                <th scope="col">Credit Account</th>
              </tr>
            </thead>
            <tbody  v-for="(expenses,index) in extraExpensesList " :key="index">
              <tr>
                <td>{{index+1}}</td>
                <td>{{expenses.expensesName}}</td>
                <td>{{expenses.extraExpenseAmt}}</td>
                <td>{{expenses.applyVat}}</td>
                <td>{{expenses.debitAccountName}} </td>
                <td>{{expenses.creditAccountName}} </td>
              </tr>
            </tbody>
            </table>
          </div>
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-10"></div>
          <div class="p-field p-col-12 p-md-1">
            <Button class="p-button-raised" @click.prevent="$router.back()" label="Back"/>
          </div>
        </div>
     </div>
    </section>
</template>
<script>
import Button from 'primevue/button'
import Dialog from 'primevue/dialog'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import InputText from 'primevue/inputtext'
export default {
  name: 'stockTransorDetailReport',
  props: ['salesHeaderObj'],
  data() {
    return {
      inventoryInOutDetailList: [],
      extraExpensesList: [],
      showPosDialog: false,
      posDetailList: [],
      filters: {}
    }
  },
  mounted() {
    this.searchInventoryOutDetail()
    this.extraExpenseList()
  },
  methods: {
    async searchInventoryOutDetail() {
      if (this.salesHeaderObj === undefined) {
        this.$router.back()
        return
      }
      let resp = await this.$store.dispatch('loadStockTransforDetail', this.salesHeaderObj.id)
      this.inventoryInOutDetailList = resp.data.data
    },
    // async extraExpenseList() {
    //   let resp = await this.$store.dispatch('extraExpensesSalesList', this.salesHeaderObj.id)
    //   if (resp.data.status === 'SUCCESS') {
    //     this.extraExpensesList = resp.data.data
    //   }
    // },
    checkPos() {
      if (this.$store.getters.modules.includes(',7.')) {
        return true
      }
    },
    cancel() {
      this.showPosDialog = false
    }
    // async posDetail(id) {
    //   let posDetail = {
    //     headerId: this.salesHeaderObj.id,
    //     itemId: id
    //   }
    //   let response = await this.$store.dispatch('posSalesDetailBySalesHeaderId', posDetail)
    //   if (response.data.status === 'SUCCESS') {
    //     this.posDetailList = response.data.data
    //   }
    //   this.showPosDialog = true
    // }
  },
  components: {
    Button,
    Dialog,
    DataTable,
    Column,
    InputText
  }
}
</script>
<style scoped src="@../../../static/css/purchase.css" >

</style>



// WEBPACK FOOTER //
// stockTransforDetails.vue?c2388c62